import React from 'react'

import { PostList } from '@/components/post-list/post-list.component'

import s from './favorite.module.less'

export const FavorContainer: React.FC = () => {
  return (
    <div className={s.container}>
      <PostList key='favor' type='favor' />
    </div>
  )
}
